import isBefore from 'date-fns/isBefore'
import isSameDay from 'date-fns/isSameDay'
import formats, { GENESYS, TCG } from '../data/formats'
import rarities from '../data/rarities'

export const printIsReleased = (print, userLanguage) => setIsReleased(print.set, print, userLanguage)

export const setIsReleased = (set, print, userLanguage) => {
	let date

	if (userLanguage === 'en-US') {
		date = print?.release || set.releaseNa || set.releaseEu
	} else {
		date = print?.release || set.releaseEu || set.releaseNa
	}

	return date ? isBefore(new Date(date), new Date()) || isSameDay(new Date(date), new Date()) : false
}

export const getSetLink = set => `/set/${set.format !== TCG ? `${formats[set.format].slug}/` : ''}${set.slug}`

export const getPrintLink = (print, cardSlug, setNumber) => `/card/${cardSlug}${setNumber && print.rarity ? `/${setNumber}-${print.cardNumber || '???'}-${rarities[print.rarity].abbr}${print.artworkNumber && print.artworkNumber !== 1 ? `-ALT${print.artworkNumber}` : ''}` : ''}`

export const getLimitedListLink = (formatId) => formatId === GENESYS ? '/points-list/genesys' : `/limited-list/${formats[formatId].slug}`
